/**
 * LastModified Component
 * Displays last modification timestamp with formatting
 */

import React from 'react';
import { formatLastModified } from '../../utils/recordTracker';
import { Clock } from 'lucide-react';

/**
 * LastModified component
 * @param {Object} props
 * @param {Date} props.date - Last modification date
 * @param {boolean} props.showIcon - Whether to show clock icon (default: true)
 * @param {boolean} props.includeTime - Whether to include time in format (default: true)
 * @param {string} props.variant - Display variant ('default', 'compact', 'tooltip')
 * @param {Object} props.style - Additional styles
 */
const LastModified = ({ 
  date, 
  showIcon = true, 
  includeTime = true,
  variant = 'default',
  style = {} 
}) => {
  if (!date) {
    return (
      <span 
        style={{
          fontSize: '11px',
          color: '#9ca3af',
          fontStyle: 'italic',
          ...style
        }}
      >
        Never modified
      </span>
    );
  }

  const formattedDate = formatLastModified(date, includeTime);
  const fullTimestamp = date.toLocaleString();

  const baseStyle = {
    fontSize: '11px',
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    ...style
  };

  if (variant === 'compact') {
    return (
      <span 
        style={{
          ...baseStyle,
          fontSize: '10px'
        }}
        title={`Last modified: ${fullTimestamp}`}
      >
        {showIcon && <Clock size={10} />}
        {formattedDate}
      </span>
    );
  }

  if (variant === 'tooltip') {
    return (
      <span 
        style={{
          ...baseStyle,
          cursor: 'help',
          textDecoration: 'underline',
          textDecorationStyle: 'dotted'
        }}
        title={`Last modified: ${fullTimestamp}`}
      >
        {showIcon && <Clock size={12} />}
        {formattedDate}
      </span>
    );
  }

  return (
    <div 
      style={baseStyle}
      title={`Last modified: ${fullTimestamp}`}
    >
      {showIcon && <Clock size={12} />}
      <span>{formattedDate}</span>
    </div>
  );
};

export default LastModified;
